import { createTheme } from '@mui/material/styles';
import { DefaultAgColor } from '../stories/Styles/AgColor';
import { styleMappings } from '../stories/Styles/AgTypography';
import { ThemeColors } from '../stories/Styles/AgColor';

export const createAgTheme = (colors: ThemeColors | null = null) => {
  const activeColors = colors || DefaultAgColor;

  return createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: activeColors.secondaryDark,
        light: activeColors.secondaryMain,
        dark: activeColors.secondaryLight, // not used!?
      },
      secondary: {
        main: activeColors.primaryMain,
        light: activeColors.primaryLight,
        dark: activeColors.primaryDark, // not used!?
      },
      error: {
        main: activeColors.errorMain,
        dark: activeColors.errorLight, // not used!?
        light: activeColors.errorHighlight,
      },
      action: {
        disabled: activeColors.grey0,
      },
      // warning: {
      //   main: '#FCCB29',
      // },
      // info: {
      //   main: '#007BFF',
      // },
      // success: {
      //   main: '#468847',
      //   light: '#DFF0D8',
      // },
      // mode,
      // tonalOffset,
      // contrastThreshold
      // common
      // grey: {
      //   50: 'red',
      // } as Color,
      text: {
        primary: '#666666', // what is this?
        secondary: '#888888', // what is this?
      },
      // divider
      // action: {
      //   // active: '#FFFFFF',
      //   hover: '#CF9C00',
      //   // hoverOpacity: 100,
      //   selected: '#AD8200',
      //   // selectedOpacity: 100,
      //   disabled: '#FFFFFF',
      //   // disabledOpacity: 100,
      //   disabledBackground: '#A3A3A3',
      //   // focus: 'red',
      //   // focusOpacity: 100,
      //   // activatedOpacity: 100,
      // },
      // background: {
      //   default: '#FFFFFF',
      //   paper: '#F7F7F7',
      // },
      // getContrastText: (background: string) => {
      //   return '#000000';
      //   return getContrastRatio(background, '#c6c4c4') >= 2 ?
      //     getContrastRatio(background, '#c6c4c4') <= 3 ?
      //       '#ffffff' : '#c6c4c4' :
      //     getContrastRatio(background, '#001f29') <= 3 ?
      //       '#000000' : '#001f29';
      // }
    },
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          listbox: {
            '& .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
              ...styleMappings['AP.Paragraph.Large.Regular'],
              backgroundColor: activeColors.secondaryLight2,
            },
            '& .MuiAutocomplete-option.Mui-focused': {
              ...styleMappings['AP.Paragraph.Large.Regular'],
              backgroundColor: activeColors.secondaryLight2,
            },
            '& .MuiAutocomplete-option[aria-selected="true"]': {
              ...styleMappings['AP.Paragraph.Large.Regular'],
              backgroundColor: activeColors.secondaryLight2,
            },
          },
          option: {
            height: '44px',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '4px',
            fontFamily: 'Inter, Roboto, sans-serif',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '12px',
            lineHeight: '12px',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            padding: '10px 24px',
            // borderColor: '#FFFFFF',
            // borderStyle: 'solid',
            // color: '#FFFFFF', // Set the default button color
            // '&:hover': {
            //   backgroundColor: '#999933', // Set the hover background color
            // },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            borderRadius: '4px',
            width: '100%',
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            width: '100%',
          },
        },
      },
    },
    // typography: {
    //   fontFamily: 'Inter, Roboto, sans-serif',
    //   h1: {
    //     fontSize: '32px',
    //     fontWeight: 'bold',
    //     lineHeight: '44px',
    //     color: '#141414', // AxsariDarkGreen
    //     marginBottom: '1rem',
    //   },
    //   h2: {
    //     fontSize: '20px',
    //     fontWeight: 'bold',
    //     lineHeight: '28px',
    //     color: '#141414', // AxsariMediumGray
    //     marginBottom: '0.75rem',
    //   },
    //   //it breaks layout in terms of fontSize, will refactor after design meeting
    //   h3: {
    //     fontSize: '14px',
    //     fontWeight: 'bold',
    //     lineHeight: '18px',
    //     color: '#141414', // AxsariMediumGray
    //     marginBottom: '0.5rem',
    //   },
    //   h4: {
    //     fontSize: '12px',
    //     fontWeight: 'bold',
    //     lineHeight: '16px',
    //     color: '#141414', // AxsariMediumGray
    //   },
    //   h5: {
    //     fontSize: '10px',
    //     fontWeight: 'bold',
    //     lineHeight: '20px',
    //     color: '#141414', // AxsariMediumGray
    //   },
    //   body1: {
    //     fontSize: '14px',
    //     fontWeight: 400,
    //     lineHeight: '26px',
    //     color: '#141414', // AxsariMediumGray
    //   },
    //   caption: {
    //     fontSize: '0.8rem',
    //     color: '#CCCCCC', // AxsariLightGray
    //   },
    // },
  });
};

export const AgTheme = createAgTheme();
